export default "__VITE_ASSET__CPmix9q6__"